import React from 'react';
import PropTypes from 'prop-types';

import dayjs from 'dayjs';

import styles from './productPurchaseCard/ProductPurchaseCard.m.sass';

import OptionFilters from '../optionFilters/OptionFilters';
import FieldSelect from '../fields/fieldSelect/FieldSelect';
import DateHint from './dateHint/DateHint';

export default class ProductPurchaseOccurrence extends React.PureComponent {
  constructor(props) {
    super(props);

    const filters = props.eventParams.optionValues && props.eventParams.optionValues.reduce((acc, optionValue) => {
      acc[optionValue.optionId] = optionValue.id;

      return acc;
    }, {});

    this.state = {filters: filters || {}};
  }

  onFilterChange = filters => {
    const {eventParams, selectedVariant, occurrences, onChange} = this.props;

    const variantOccurrences = occurrences.filter(occurrence => occurrence.productVariant.code === selectedVariant.code);
    const filteredOccurrences = variantOccurrences.filter(
      ({optionValues}) => Object.entries(filters)
        .filter(([filter, value]) => !!value)
        .every(([filter, value]) => optionValues.some(({optionId, id}) => optionId == filter && id == value))
    );

    const selectionMatchingOccurrence = filteredOccurrences.find(occurrence => occurrence.occurrence === eventParams.occurrence);

    if (selectionMatchingOccurrence) {
      if (selectionMatchingOccurrence.id !== eventParams.id) {
        onChange(selectionMatchingOccurrence);
      }
    } else {
      if (filteredOccurrences.length) {
        onChange({error: true});
      } else {
        onChange({});
      }
    }

    this.setState({filters});
  };

  render() {
    const {eventParams, selectedVariant, occurrences, onChange} = this.props;
    const {filters} = this.state;

    const variantOccurrences = occurrences.filter(occurrence => occurrence.productVariant.code === selectedVariant.code);
    if (!variantOccurrences.length) {
      return false;
    }

    const filteredOccurrences = variantOccurrences.filter(
      ({optionValues}) => Object.entries(filters)
        .filter(([filter, value]) => !!value)
        .every(([filter, value]) => optionValues.some(({optionId, id}) => optionId == filter && id == value))
    );

    const slicedOccurrences = filteredOccurrences.filter(
      (occurrence, idx) => idx < 10 || occurrence.occurrence === eventParams.occurrence
    );

    return (
      <div className={styles.productCard_group}>
        <div className={styles.productCard_toggle}>
          <OptionFilters
            filters={variantOccurrences[0].preset.options}
            values={filters}
            onChange={this.onFilterChange}
          />
        </div>

        <div className={styles.productCard_dropdown}>
          <FieldSelect
            input={{
              value: eventParams.occurrence || '',
              onChange: evt => onChange(variantOccurrences.find(occurrence => occurrence.occurrence === evt.target.value) || {})
            }}
          >
            {!slicedOccurrences.length ? (
              <option disabled hidden value="">First available</option>
            ) : (
              <option disabled hidden value="">Please pick the date</option>
            )}

            {slicedOccurrences.map(occurrence => (
              <option
                key={occurrence.occurrence}
                value={occurrence.occurrence}
              >
                {
                  DateHint.getDateHint(dayjs(occurrence.occurrence))
                    ? DateHint.getDateHint(dayjs(occurrence.occurrence)).toUpperCase() + ', '
                    : false
                }
                {
                  dayjs(occurrence.occurrence).format('DD MMM, HH:mm').toUpperCase()
                  + ` (${(Intl && Intl.DateTimeFormat().resolvedOptions().timeZone && Intl.DateTimeFormat().resolvedOptions().timeZone.replace('/', ', ')) || dayjs().format('Z')})`
                }
              </option>
            ))}
          </FieldSelect>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productPurchase/ProductPurchaseOccurrence.js